import { render, staticRenderFns } from "./RouteUpload.vue?vue&type=template&id=1638f81c&"
import script from "./RouteUpload.vue?vue&type=script&lang=js&"
export * from "./RouteUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports